import omit from 'lodash/omit';
import { MappedProviders, PreferredProviderInterface, Profile } from './types';
import { ConsumerProfileInterface } from './monorepo.types';

export const normalizeProviders = (providers: PreferredProviderInterface[] = []) =>
  providers.map((p: PreferredProviderInterface) => ({
    id: p.resourceId,
    name: p.resourceDisplay,
    personnelId: parseInt(p.personnelId as string, 10),
    specialties: p.specialitySet,
    profileImageUrl: p.providerProfileImageUrl,
    resourceDisplay: p.resourceDisplay,
    primary: p.primary
  })) as MappedProviders[];

export const normalizeProfile = (
  profile: ConsumerProfileInterface = {} as ConsumerProfileInterface
): Profile => {
  const newProfile = omit(profile, 'insurances'); // for handling: GET_PROFILE_SUCCESS is executed after GET_PROFILE_FOR_INSURANCE_SUCCESS which sets the insurances state to []
  return {
    ...newProfile,
    preferredProviders: normalizeProviders(profile.preferredProviders)
  } as ConsumerProfileInterface & Profile;
};
